/**
 * @name ForgotIdPage.jsx
 * @description 아이디 찾기 페이지
 * - 이름 + 전화번호 입력 후 일치하는 아이디 화면에 표시
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { post } from '@utils/axios_api';
import './Login.css';

const ForgotIdPage = () => {
  const [form, setForm] = useState({ name: '', phoneNo: '' });
  const [result, setResult] = useState(null);  // 찾은 아이디 목록 (배열)
  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const sanitized = name === 'phoneNo' ? value.replace(/\D/g, '') : value;
    setForm((prev) => ({ ...prev, [name]: sanitized }));
    setResult(null);
    setErrorMsg('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phoneNo) {
      setErrorMsg('이름과 전화번호를 모두 입력해 주세요.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await post('/auth/forgot-id', form, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.result.success) {
        setResult(response.result.userIds);
        setErrorMsg('');
      } else {
        setResult(null);
        setErrorMsg(response.result.message || '일치하는 계정이 없습니다.');
      }
    } catch (err) {
      // 서버/네트워크 에러는 axios interceptor가 이미 toast로 표시하고 throw함
      // → 여기서 setErrorMsg 추가 시 toast + 인라인 에러 이중 표시되므로 console만 처리
      console.error('아이디 찾기 오류:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main-container">
      <div className="login-container">
        {/* 로고 */}
        <div className="logo">
          <Link to="/">
            <img src="/img/logo.png" alt="회사 로고" style={{ cursor: 'pointer' }} />
          </Link>
        </div>

        <div className="login-form">
          <h1>아이디 찾기</h1>
          <p style={{ color: '#666', marginBottom: '20px', fontSize: '0.9rem' }}>
            가입 시 등록한 이름과 전화번호를 입력해 주세요.
          </p>

          {/* 결과 표시 */}
          {result && (
            <div style={{
              background: '#e8f4fd',
              border: '1px solid #2196F3',
              borderRadius: '6px',
              padding: '16px',
              marginBottom: '16px',
              textAlign: 'center'
            }}>
              <p style={{ margin: 0, color: '#555', fontSize: '0.9rem' }}>
                {result.length === 1 ? '회원님의 아이디는' : `일치하는 아이디 ${result.length}개`}
              </p>
              {result.map((id, index) => (
                <p key={index} style={{ margin: '8px 0 0', fontWeight: 'bold', fontSize: '1.3rem', color: '#1976D2' }}>
                  {id}
                </p>
              ))}
              <p style={{ margin: '8px 0 0', color: '#888', fontSize: '0.8rem' }}>
                아이디가 다를 경우 관리자에게 문의해 주세요.
              </p>
            </div>
          )}

          {/* 에러 메시지 */}
          {errorMsg && (
            <p className="error-message red" style={{ marginBottom: '12px' }}>{errorMsg}</p>
          )}

          {/* 입력 폼 - 아이디를 찾은 경우 숨김 */}
          {!result && (
            <form onSubmit={handleSubmit}>
              <div className="login_input_wrap">
                <input
                  type="text"
                  name="name"
                  placeholder="이름을 입력해 주세요."
                  value={form.name}
                  onChange={handleChange}
                  maxLength="20"
                  style={{ width: '100%', padding: '12px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '1rem' }}
                />
                <input
                  type="text"
                  name="phoneNo"
                  placeholder="전화번호를 입력해 주세요. (예: 01012345678)"
                  value={form.phoneNo}
                  onChange={handleChange}
                  maxLength="11"
                  style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '1rem' }}
                />
                <p style={{ fontSize: '11px', color: '#888', margin: '3px 0 0' }}>- 없이 숫자만 입력하세요.</p>
              </div>
              <button
                type="submit"
                className="login-button"
                disabled={isLoading}
                style={{ marginTop: '16px' }}
              >
                {isLoading ? '조회 중...' : '아이디 찾기'}
              </button>
            </form>
          )}

          {/* 하단 링크 */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '20px', fontSize: '0.9rem' }}>
            <Link to="/login" style={{ color: '#555' }}>로그인</Link>
            <span style={{ color: '#ddd' }}>|</span>
            <Link to="/forgot-password" style={{ color: '#555' }}>비밀번호 찾기</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ForgotIdPage };
